import React from 'react';

// GLOBAL VARIABLES
import { INTERFACE, DASHBOARD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// ROUTER COMPONENTS
import { Navigate, Route, Routes } from 'react-router-dom';

// GLOBAL PARTS
import Report from 'parts/report/Report';

// ROUTES
import Favorites from './dashboard/Favorites';
import Reports from './dashboard/Reports';

const paths = [
  // STANDARD REPORTS
  makePath(DASHBOARD.reports, DASHBOARD.report, ':reportID'),
  makePath(DASHBOARD.reports, DASHBOARD.report, ':reportID', DASHBOARD.list),
  makePath(DASHBOARD.favorites, DASHBOARD.report, ':reportID'),
  makePath(DASHBOARD.favorites, DASHBOARD.report, ':reportID', DASHBOARD.list),
  // CUSTOM REPORTS
  makePath(DASHBOARD.reports, DASHBOARD.custom, ':reportCode'),
  makePath(DASHBOARD.reports, DASHBOARD.custom, ':reportCode', DASHBOARD.list),
  makePath(DASHBOARD.favorites, DASHBOARD.custom, ':reportCode'),
  makePath(DASHBOARD.favorites, DASHBOARD.custom, ':reportCode', DASHBOARD.list)
];


// MAIN COMPONENT
const Dashboard = () => (
  <Routes>
    <Route path={makePath(DASHBOARD.reports)} element={<Reports />} />
    <Route path={makePath(DASHBOARD.favorites)} element={<Favorites />} />
    {paths.map((path, index) => <Route key={index} path={path} element={<Report />} />)}
    <Route path="*" element={<Navigate to={makePath(INTERFACE.dashboard, DASHBOARD.reports)} replace />} />
  </Routes>
);

// EXPORT
export default Dashboard;
